import { alpha, Box, useTheme } from '@mui/material'
import StrategyRichTextField from './StrategyRichTextField'

interface StrategyNotesHeaderProps {
  newNoteContent: any
  setNewNoteContent: any
  handleAddNote: any
  isCreatingNote: any
  setIsCreatingNote: any
  handleClear?: any
  onClear?: any
}

const StrategyNotesHeader = ({
  newNoteContent,
  setNewNoteContent,
  handleAddNote,
  isCreatingNote,
  setIsCreatingNote,
  handleClear,
  onClear,
}: StrategyNotesHeaderProps) => {
  const theme = useTheme()
  const hoverBgColor = alpha(theme.palette.text.primary, 0.3)
  return (
    <Box
      sx={{
        p: 1.2,
        ml: 2.5,
        border: '1px solid',
        justifyContent: 'center',
        textAlign: 'center',
      }}
    >
      <StrategyRichTextField
        content={newNoteContent}
        onContentChange={setNewNoteContent}
        isCreatingNote={isCreatingNote}
        setIsCreatingNote={setIsCreatingNote}
        handleAddNote={handleAddNote}
      />
    </Box>
  )
}

export default StrategyNotesHeader
